// @flow
import React from 'react';
import t from './../../i18n/I18n';
import Modal2 from './../Modal2.js';
import { ThemeSetup } from '../../themes/ThemeSetup';
import './../Modal2.css';
import CollectionModalV2 from '../collections/collection-modal-v2/CollectionModalV2';
import { Button } from './../../common';

type Props = {
  onCancel: Function,
  onSubmit: Function,
  type: string,
  inputText: string,
  inputPlaceholder: string,
  submitBtnText: string,
  passwordVisible: boolean,
  errorMsg: string
};


export default class CredentialsModal {
  static getCredentialsModal(props: Props) {
    const credentials = { value: '' };
    const getCredentials = (() => {
      return this.value;
    }).bind(credentials);
    const setCredentials = ((v) => {
      this.value = v;
    }).bind(credentials);

    return (
      <div name="CredentialsModal">
        <CollectionModalV2
          name="CredentialsPopupModal"
          icon={'images/evolphin-logo-color.svg'}
          onClose={props.onCancel}
          okBtnText={props.submitBtnText ? props.submitBtnText : t('Enter')}
          onOk={() => {
            let val = getCredentials();
            setCredentials('');
            props.onSubmit(val);
          }}>
          <div className="cred-modal-wrapper">
            <p className="cred-modal-desc">{props.inputText ? props.inputText : t('COLLECTION_PASSWORD_REQUIRED')}</p>
            <div className="cred-modal-input-wrapper" style={{display:'flex'}}>
              <input
                className="full-width"
                ref="inputBox"
                type={props.passwordVisible ? "input" : (props.type ? props.type : "password")}
                placeholder={props.inputPlaceholder ? props.inputPlaceholder : t('PASSWORD')}
                autoFocus="true"
                onKeyUp={(event) => {
                  if (event.which == 13) {
                    let val = event.target.value;
                    event.target.value = '';
                    props.onSubmit(val);
                  }
                }}
                onChange={(event) => setCredentials(event.target.value)}
                style={{marginRight: '10px'}}
              />
            { !props.type || props.type === "password" ? (
              <Button
                type="LINK"
                icon={ThemeSetup.getImageURL('eye_' + (props.passwordVisible ? 'black' : 'gray') + '.svg')}
                text=""
                className="share-coll-modal-password-eye-icon"
                onClick={(e) => { props.passwordVisible = !props.passwordVisible; this.refs.inputBox.type = props.passwordVisible ? "input" : "password"; } }
              />
              ) : null
            }
            </div>
            {props.errorMsg ? <p className='cred-modal-error'>{props.errorMsg}</p> : null}
          </div>
        </CollectionModalV2>
      </div>
    );
  }
}
